// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export const NO_BIND_TO = '-1';
